/*getItemDetail
 * @Description:订单管理接口文件
 * @Autor: zczhang
 * @Date: 2021-03-15 14:14:12
 * @LastEditors: zczhang
 * @LastEditTime: 2021-03-15 18:36:36
 */

import request from "@/api/request.js"
import { post } from "@/api/requrestHttp"

const getItemDtailUrl = "/ypt/admin/order/findOrderRecordByToday"
const getDataUrl = "/ypt/admin/order/findOrderRecordByToday"
const remindUrl = "/sqyl/admin/pay/remind"
const assignUrl = "/sqyl/admin/pay/appoint"

const getItemDetail = async data => await post(getItemDtailUrl, data)
const getData = async data => await post(getDataUrl, data)
const setRemind = async data => await post(remindUrl, data)
const setAssign = async data => await post(assignUrl, data)
export { getItemDetail, getData, setRemind, setAssign }
